export default {
  errorDefault: "Une erreur s'est produite",
  unknown: 'Inconnu',
};
